// Formatacao e comparacao de enderecos do pedido para exibicao

interface AddressLike {
    street?:string
    number?:string
    complement?:string
    neighborhood?:string
    city?:string
    state?:string
    postalCode?:string
}

// Campos que definem "onde" e o endereco. Complemento fica de fora: canais
// costumam preencher entrega e cobranca com textos diferentes para o mesmo lugar
// ("Referencia: portaria 24h" x "portaria 24h").
const LOCATION_FIELDS:Array<keyof AddressLike> = ['street', 'number', 'neighborhood', 'city', 'state']

export function postalCodeDigits(value?:string):string {
    return String(value || '').replace(/\D/g, '')
}

// "13298492" -> "13298-492". Valores fora do padrao de 8 digitos voltam como vieram.
export function formatPostalCode(value?:string):string {
    const digits = postalCodeDigits(value)

    if (digits.length !== 8) {
        return String(value || '').trim()
    }

    return `${digits.slice(0, 5)}-${digits.slice(5)}`
}

function normalize(value?:string):string {
    return String(value || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[.,]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
}

export function isSameLocation(a?:AddressLike, b?:AddressLike):boolean {
    if (!a || !b) {
        return false
    }

    const aCep = postalCodeDigits(a.postalCode)
    const bCep = postalCodeDigits(b.postalCode)

    if (!aCep && !a.street) {
        return false
    }

    return aCep === bCep && LOCATION_FIELDS.every((f) => normalize(a[f]) === normalize(b[f]))
}

export function hasSameComplement(a?:AddressLike, b?:AddressLike):boolean {
    return normalize(a && a.complement) === normalize(b && b.complement)
}
